module.exports = __webpack_public_path__ + "static/media/Week 5 Saturday.7473738f.png";